import React, { Component, Fragment } from "react";
import List from "./List";
import Footer from "../../utilities/Footer";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";
import Header from "../Header";
import { Link } from "react-router-dom";
import {
    list,    
    remove, 
    search,
} from "../../../services/course";


class CoursesListing extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        search: false,
        create: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all"
    };

    delete = id => {
        return remove(id).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp.splice(i, 1);
                    this.setState({ items: temp });
                }
            }
        });
    };

    onQueryChange = field => {
        this.setState({ query: field.target.value });
        //console.log(field.target.value);
    };

    submitSearch = e => {
        e.preventDefault();
        if (this.state.query.length >= 1) {
            this.search(this.state.query);
        } else {
            this.clear();
        }
    };

    clear = () => {
        this.setState({ loading: true });
        list()
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });        
    };

    search = query => {
        this.setState({ loading: true });
        search(query).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                search: true,
                query: query,
                loading: false
            });
        });
    };

    componentDidMount() {
        list()
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    

    render() {
        return (
            <Fragment>
                <Header></Header>
                <div className="main-content  mt-6">
                    <Header></Header>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="header">
                                    <div className="header-body">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h1 className="header-title">
                                                    Courses
                                                </h1>
                                                <h6 className="header-pretitle">
                                                    Overview all available
                                                    Courses
                                                </h6>
                                            </div>
                                            <div className="col-auto">
                                                
                                                <Link
                                                    to={
                                                        "/admin/courses/create"
                                                    }
                                                    className="btn btn-primary"
                                                >
                                                    + Add Course
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <form
                                                    onSubmit={this.submitSearch}
                                                    className="row align-items-center"
                                                >
                                                    <div className="col-auto pr-0">
                                                        <span className="fe fe-search text-muted"></span>
                                                    </div>
                                                    <div className="col">
                                                    <input
                                                            onChange={this.onQueryChange.bind(
                                                                this
                                                            )}
                                                            value={
                                                                this.state.query
                                                            }
                                                            type="search"
                                                            className="form-control form-control-flush search"
                                                            placeholder="Search"
                                                        ></input>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : this.state.items.length >= 1 ? (
                                            <table className="table table-sm table-nowrap card-table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <div className="custom-control custom-checkbox table-checkbox">
                                                                #
                                                            </div>
                                                        </th>
                                                        <th>Title</th>                                                       
                                                        <th>Keywords</th>
                                                        <th>Basic Price</th>
                                                        <th>Plus Price</th>
                                                        <th>Duration</th>
                                                        <th>Date</th>
                                                        <th>Status</th>
                                                        <th className="Options">
                                                            Options
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list">
                                                    {this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <List                                                                    
                                                                getItem={
                                                                    this
                                                                        .record
                                                                }
                                                                update={
                                                                    this
                                                                        .update
                                                                }
                                                                delete={
                                                                    this
                                                                        .delete
                                                                }
                                                                item={item}
                                                                index={
                                                                    index
                                                                }
                                                                key={index}
                                                                ></List>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <NoData></NoData>
                                        )}
                                    </div>
                                    <div>
                                        <Footer
                                            changePage={this.changePage}
                                            totalPages={this.state.meta.pages}
                                            curentPage={this.state.meta.page}
                                        ></Footer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </Fragment>
        );
    }
}
CoursesListing.contextType = AppContext;
export default CoursesListing;



// WEBPACK FOOTER //
// ./src/components/admin/courses/CoursesListing.js